import UsersService from 'src/services/users'

class User {
  constructor (_user) {
    if (typeof _user !== 'undefined') {
      this.id = _user.id ? _user.id : null
      this.first_name = _user.first_name ? _user.first_name : null
      this.last_name = _user.last_name ? _user.last_name : null
      this.email = _user.email ? _user.email : null
      this.franchise_id = _user.franchise ? _user.franchise.id : _user.franchise_id ? _user.franchise_id : null
      this.organization_id = _user.organization ? _user.organization.id : _user.organization_id ? _user.organization_id : null
      this.is_basic = _user.is_basic ? _user.is_basic : 0
      this.is_demo = _user.is_demo ? _user.is_demo : 0
      this.is_aria = _user.is_aria ? _user.is_aria : 0
      this.is_aria_insights = _user.is_aria_insights ? _user.is_aria_insights : 0
      this.demo_until = _user.demo_until ? _user.demo_until : null
      this.is_franchise_admin = _user.is_franchise_admin ? _user.is_franchise_admin : false
      this.is_organization_admin = _user.is_organization_admin ? _user.is_organization_admin : false
      this.is_password_manager = _user.is_password_manager ? _user.is_password_manager : false
      this.is_users_admin = _user.is_users_admin ? _user.is_users_admin : false
      this.profile_image = _user.profile_image ? _user.profile_image : null
      this.is_super_admin = _user.is_super_admin ? _user.is_super_admin : false
      this.is_franchise_supervisor = _user.is_franchise_supervisor ? _user.is_franchise_supervisor : false
      this.password = _user.password ? _user.password : null
      this.password_confirm = _user.password_confirmation ? _user.password_confirmation : null
      this.password_status = _user.password_status ? _user.password_status : 0
      this.user_roles = _user.roles.length > 0 ? this._getRoles(_user.roles) : []
      this.has_activated_phone = _user.has_activated_phone ? _user.has_activated_phone : false
      this.uuid = _user.uuid ? _user.uuid : null
      this.google2fa_secret = _user.google2fa_secret ? _user.google2fa_secret : null
      this.external_id = _user.external_id ? _user.external_id : null
    } else {
      this.id = null
      this.first_name = null
      this.last_name = null
      this.email = null
      this.franchise_id = null
      this.organization_id = null
      this.is_basic = 0
      this.is_demo = 0
      this.is_aria = 0
      this.is_aria_insights = 0
      this.demo_until = new Date().toISOString().slice(0, 19).replace('T', ' ')
      this.is_franchise_admin = false
      this.is_organization_admin = false
      this.is_password_manager = false
      this.is_users_admin = false
      this.profile_image = null
      this.is_super_admin = false
      this.is_franchise_supervisor = false
      this.password = '12345678'
      this.password_confirm = '12345678'
      this.password_status = 0
      this.user_roles = []
      this.has_activated_phone = false
      this.uuid = null
      this.google2fa_secret = null
      this.external_id = null
    }
  }

  save (is_real_mail = false) {
    let payload = {
      id: this.id,
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      password: this.password,
      password_confirmation: this.password_confirm,
      franchise_id: this.franchise_id,
      organization_id: this.organization_id,
      is_basic: this.is_basic,
      is_demo: this.is_demo,
      is_aria: this.is_aria,
      is_aria_insights: this.is_aria_insights,
      demo_until: this.demo_until,
      uuid: this.uuid,
      is_real_mail: is_real_mail,
      external_id: this.external_id || null
    }
    if (this.password && this.password_confirm) {
      payload.password_status = 0
    }
    const promise = this.id ? UsersService.update(this.id, payload) : UsersService.create(payload)

    promise.then(user => {
      if (user.data) {
        this.id = user.data.id
        this.profile_image = user.data.profile_image
      }
    })

    return promise
  }

  updatePassword () {
    const payload = {
      id: this.id,
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      password: this.password,
      password_confirmation: this.password_confirm,
      password_status: this.password_status,
      franchise_id: this.franchise_id,
      organization_id: this.organization_id,
      is_basic: this.is_basic,
      is_aria: this.is_aria,
      is_aria_insights: this.is_aria_insights,
      is_demo: this.is_demo,
      demo_until: this.demo_until,
      uuid: this.uuid
    }

    const promise = this.id ? UsersService.update(this.id, payload) : UsersService.create(payload)

    promise.then(user => {
      if (user.data) {
        this.id = user.data.id
        this.profile_image = user.data.profile_image
      }
    })

    return promise
  }

  updateDemo () {
    const payload = {
      id: this.id,
      is_demo: this.is_demo,
      demo_until: this.demo_until
    }
    const promise = UsersService.updateDemo(payload)

    return promise
  }

  static fetch (id) {
    return UsersService.fetch(id).then(user => {
      return new this(user)
    })
  }

  static delete (id) {
    return UsersService.delete(id)
  }

  static disable (user) {
    const payload = {
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      franchise_id: user.franchise.id,
      organization_id: user.organization.id,
      franchise_organization_id: user.organization.id,
      is_basic: user.is_basic,
      status: user.status,
      change_state: true
    }
    return UsersService.update(user.id, payload)
  }

  _getRoles (userRoles) {
    return userRoles.map(role => {
      return {
        id: role.pivot.id,
        name: role.name,
        role_id: role.pivot.role_id,
        location_id: role.pivot.location_id,
        location_name: role.location_name,
        franchise_id: role.pivot.franchise_id ? role.pivot.franchise_id : role.location_franchise_id,
        franchise_organization_id: role.organization_id ? role.organization_id : role.pivot.franchise_organization_id,
        user_id: role.pivot.user_id
      }
    })
  }
}

export default User
